import type { DocPageContent } from '../docs-content'

const page = {
  order: 4,
  slug: 'editor',
  title: '编辑器布局与导航',
  description:
    '工具栏、媒体侧边栏、预览监视器、时间轴、属性面板，以及编辑、调色和运动工作区。',
  category: '入门',
  related: ['concepts', 'timeline', 'keyboard-shortcuts'],
  sections: [
    {
      title: '主要界面区域',
      blocks: [
        {
          kind: 'list',
          items: [
            '**编辑器工具栏**（顶部）：返回项目、工作区标签页、项目规格、语言、设置、键盘快捷键、保存、导出，以及渲染队列。',
            '**媒体侧边栏**（左侧）：你的素材与创建工具。',
            '**预览监视器**：带叠加层、遮罩、示波器和播放控件的当前帧。',
            '**时间轴**（底部）：轨道、片段、标记和编辑工具。',
            '**属性**面板：编辑你选中的一个或多个片段。',
          ],
        },
      ],
    },
    {
      title: '媒体侧边栏标签页',
      blocks: [
        {
          kind: 'table',
          headers: ['标签页', '内容'],
          rows: [
            [
              '媒体',
              '导入的素材、媒体信息、代理文件、转录稿、字幕、复合片段、缺失媒体的控件',
            ],
            ['文本', '来自单段和多段模板的文本片段'],
            ['形状', '生成式形状项'],
            ['特效', '所选片段的 GPU 特效'],
            ['转场', '可拖到切口上的转场'],
            ['AI', '本地文本转语音与音乐生成'],
          ],
        },
      ],
    },
    {
      title: '工作区',
      blocks: [
        {
          kind: 'list',
          items: [
            '**编辑**工作区（`Alt+1`）是默认的剪辑布局，用于排列、修剪、文本、形状、特效、转场与预览。',
            '**调色**工作区（`Alt+2`）专注于调色，提供所选片段的色轮、曲线和示波器。',
            '**运动**工作区融合了分层合成、关键帧、图表、预设和程序化动画——参见 [运动工作区](motion)。',
            '在“编辑”中选择一个可视片段，并在属性中打开**动画**，可查看常用预设、已应用动画状态、文本运动以及**创建运动片段**。',
            '从中间工具栏的标签页切换工作区，或使用 `Alt+1`、`Alt+2` 和 `Alt+3`。',
          ],
        },
      ],
    },
    {
      title: '获取帮助与安全操作',
      blocks: [
        {
          kind: 'list',
          items: [
            '打开**设置**以调整通用、时间轴、AI 与存储偏好。',
            '打开**键盘快捷键**以搜索命令、重新绑定按键，并导入或导出预设。',
            '经常用 `Ctrl+S` 保存；自动保存也可以按你在设置中设定的间隔运行。',
            '撤销与重做（`Ctrl+Z` 和 `Ctrl+Shift+Z`）可在出错时覆盖时间轴编辑。',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
